import { BulbFilled, BulbOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import { useThemeMode } from '@/theme/theme-provider'

/**
 * 亮/暗主题切换按钮
 * 紧凑设计：仅图标 + tooltip，置于顶栏右侧
 */
export function ThemeToggle() {
  const { mode, toggleMode } = useThemeMode()
  const isDark = mode === 'dark'

  return (
    <Tooltip title={isDark ? '切换到亮色模式' : '切换到暗色模式'} placement="bottom">
      <button
        type="button"
        onClick={toggleMode}
        aria-label={isDark ? '切换到亮色模式' : '切换到暗色模式'}
        className="app-icon-button"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: 6,
          border: '1px solid var(--ant-color-border)',
          background: 'transparent',
          color: 'var(--ant-color-text-secondary)',
          cursor: 'pointer',
          transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = 'var(--ant-color-primary)'
          e.currentTarget.style.color = 'var(--ant-color-primary)'
          e.currentTarget.style.background = 'var(--app-nav-hover-bg)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = 'var(--ant-color-border)'
          e.currentTarget.style.color = 'var(--ant-color-text-secondary)'
          e.currentTarget.style.background = 'transparent'
        }}
      >
        {isDark ? <BulbFilled /> : <BulbOutlined />}
      </button>
    </Tooltip>
  )
}
